export const ENROLLMENT_SUCCESSFUL_STATE = 'enrollmentSuccessful';
export const ENROLLMENT_PENDING_STATE = 'enrollmentPending';
export const ENROLLMENT_DECLINED_STATE = 'enrollmentDeclined';
export const CREDIT_DECLINED_BY_USER_STATE = 'creditDeclinedByUser';
export const CREDIT_SUCCESSFUL_STATE = 'creditSuccessful';
export const CREDIT_ENROLLMENT_FAILED_STATE = 'creditEnrollmentFailed';
